import { useMutation, useQuery, useQueryClient } from 'react-query';
import axios from 'axios';
import { PricingSettings } from '../models/pricingSettings';

const apiUrl = process.env.REACT_APP_BASIX_API || '';

const getPricing = async (): Promise<PricingSettings> => {
  const { data } = await axios.get(`${apiUrl}settings/Pricing`);
  return data;
};

// item 234 — company default pricing markups (integrator / group). Mirrors
// useDocumentNumbering; stored as CustomerSettings rows server-side (no migration).
const usePricingSettings = () => {
  const queryClient = useQueryClient();
  const query = useQuery('pricingSettings', getPricing);

  const mutation = useMutation(
    (pricing: PricingSettings) => axios.post(`${apiUrl}settings/Pricing`, pricing),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('pricingSettings');
      },
    },
  );

  return {
    ...query,
    pricing: query.data,
    tryUpdate: mutation.mutateAsync,
    isSaving: mutation.isLoading,
  };
};

export default usePricingSettings;
